// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1rSWs","imageDescription":"styles_imageDescription__3-l7Y","radioBox":"styles_radioBox__1-aqG"};